import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ResidentialComponent } from '../home-main/solution/residential/residential.component';
import { GetstartedComponent } from './getstarted/getstarted.component';

const Route: Routes = [
  // { path: '', component: ResidentialComponent },
  { path: 'residential', component: ResidentialComponent },
  { path: 'get-started', component: GetstartedComponent },
];

@NgModule({
  imports: [RouterModule.forChild(Route)],
  exports: [RouterModule]
})
export class GetStartedRoutingModule { }
